import {
  definitions,
  paths,
} from "../../common-fetch/generated/orders-model-api";
import { fetchItJson } from "../../common-fetch/miscellaneous/fetchItJson";
import { FetchOutput } from "../../common-fetch/miscellaneous/fetchResult";
import { getPartnerPathnameClient } from "../../getPartnerPathnameClient";

type Path = paths["/carts"];
export type Responses = Path["get"]["responses"];

export type FetchCartsOutput = FetchOutput<
  Responses["200"]["schema"],
  definitions["ProblemDetails"]
>;

export async function fetchGetCarts(): Promise<FetchCartsOutput> {
  const path: keyof paths = "/carts";

  return fetchItJson<Responses["200"]["schema"], definitions["ProblemDetails"]>(
    "authorization",
    `${getPartnerPathnameClient(true)}/Market/HostedCart/Orders/v1${path}`
  ).catch(() => {
    return { tag: "client-error", parsed: { status: 418 } };
  });
}
